import React from 'react';

import { Typography } from 'components/shared/Typography';

import { Item } from '../Item';
import { Lines } from '../Lines';
import { Action } from '../Action';

import styles from './PluginPreviewPage.module.scss';

const PluginPreviewPage = ({
  rootRef,
  containerRef,
  leftItemsRef,
  rightItemsRef,
  nextLoading,
  isLastLessonInCourse,
  lineDrawing,
  linesValidated,
  leftItems,
  rightItems,
  lines,
  correctLinesIds,
  startLinePosition,
  lesson,
  onProcessDrawing,
  onItemClick,
  onTryAgainClick,
  onNextLessonClick,
  onRestartLessonClick,
  isTestMode,
}: {
  rootRef: any;
  containerRef: any;
  leftItemsRef: any;
  rightItemsRef: any;
  nextLoading: any;
  isLastLessonInCourse: any;
  lineDrawing: any;
  linesValidated: any;
  leftItems: any;
  rightItems: any;
  lines: any;
  correctLinesIds: any;
  startLinePosition: any;
  lesson: any;
  onProcessDrawing: any;
  onItemClick: any;
  onTryAgainClick: any;
  onNextLessonClick: any;
  onRestartLessonClick: any;
  isTestMode: any;
}) => (
  <div className={styles.page} ref={rootRef}>
    <div
      className={styles.inner}
      onMouseMove={lineDrawing ? onProcessDrawing : () => {}}
    >
      <Typography variant="body1" className={styles.text}>
        {lesson.text}
      </Typography>
      <div className={styles.main}>
        <div className={styles.leftColumn}>
          {leftItems.map((leftItem: any, index: any) => {
            const pointUsed = lines.some(
              (line: any) =>
                (line.startId === leftItem.id &&
                  line.startType === leftItem.type) ||
                (line.finishId === leftItem.id &&
                  line.finishType === leftItem.type),
            );

            return (
              <Item
                key={leftItem.id + 'question'}
                id={leftItem.id}
                {...leftItem}
                pointUsed={pointUsed}
                lineDrawing={lineDrawing}
                linesValidated={linesValidated}
                correctLine={correctLinesIds.some(
                  (lineId: string) => lineId === leftItem.id,
                )}
                pointRef={leftItemsRef.current[index]}
                startLinePosition={startLinePosition}
                answersType={lesson.answersType}
                onClick={isTestMode && onItemClick}
                isTestMode={isTestMode}
              />
            );
          })}
        </div>
        <Lines
          lineDrawing={lineDrawing}
          lines={lines}
          containerRef={containerRef}
        />
        <div className={styles.rightColumn}>
          {rightItems.map((rightItem: any, index: any) => {
            const pointUsed = lines.some(
              (line: any) =>
                (line.startId === rightItem.id &&
                  line.startType === rightItem.type) ||
                (line.finishId === rightItem.id &&
                  line.finishType === rightItem.type),
            );

            return (
              <Item
                key={rightItem.id + 'answer'}
                className={styles.answerItem}
                {...rightItem}
                id={rightItem.id}
                pointUsed={pointUsed}
                lineDrawing={lineDrawing}
                linesValidated={linesValidated}
                correctLine={correctLinesIds.some(
                  (lineId: string) => lineId === rightItem.id,
                )}
                pointRef={rightItemsRef.current[index]}
                startLinePosition={startLinePosition}
                answersType={lesson.answersType}
                onClick={isTestMode && onItemClick}
                isTestMode={isTestMode}
              />
            );
          })}
        </div>
      </div>
      <div className={styles.actions}>
        {isTestMode && (
          <Action
            nextLoading={nextLoading}
            isLastLessonInCourse={isLastLessonInCourse}
            linesValidated={linesValidated}
            correctLinesIds={correctLinesIds}
            lines={lines}
            onTryAgainClick={onTryAgainClick}
            onNextLessonClick={onNextLessonClick}
            onRestartLessonClick={onRestartLessonClick}
          />
        )}
      </div>
    </div>
  </div>
);

export default React.memo(PluginPreviewPage) as any;
